import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import "./CommonDashboard.css";
import { Users } from "./Users";
import { MyUserForm } from "./MyUserForm";
import { setEmms } from "../redux/slices/emmsSlice";


export function UsersDashboard() {
  const dispatch = useDispatch();
  const api = localStorage.getItem("api");
  const emms = useSelector((state) => state.emms);
  const headers = useSelector((state) => state.header);
  const [users,setUsers]=useState([])
  const [selectedUserForEdit,setSelectedUserForEdit]=useState({})
  const [selectedUserForDelete,setSelectedUserForDelete]=useState({})
  const loggedInUser=useSelector(state=>state?.user?.user)
  const [groups,setGroups]=useState([])
  
  
  

  const [errors, setErrors] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
 
  const [sites,setSites]=useState([])


const fetchSites = async () => {
  const requestBody = {
    path: "site",
    query: {},
    body: {},
    requestType: "GET",
  };

  try {
    const response = await axios.post(
      `${api}/auth/piggyback`,
      requestBody,
      headers
    );

    

    setSites(response?.data || []);
    setErrors(false);

    return response?.data || [];
  } catch (error) {
    console.error("Failed to fetch sites:", error);

    return [];
  }
};

const fetchGroups = async (emmsId) => {

  if (!emmsId) {
  console.error("EMMS ID not found. Unable to fetch groups.");
  setErrors(true);
  return null;
  }

  const requestBody = {
    path: "groups",
    query: {},
    emmsId,
    body: {},
    requestType: "GET",
    headers: headers,
  };

  try {
    const response = await axios.post(
      `${api}/emms/piggyback`,
      requestBody,
      headers
    );
  
    setGroups(response?.data || [])
    return response?.data || []

  } catch (error) {
    setErrors(true)
    console.error("Failed to fetch groups:", error);
    return null;
  }
};




  const fetchData = async () => {
    setIsLoading(true);

      let emmsId=emms?.emms?.[0]?.id;
      if(!emmsId){
      try {
        const {data:emms}= await axios.get(api + `/list/emms`, headers)
        dispatch(setEmms(emms))
        emmsId=emms?.[0]?.id
      } catch (error) {
        setErrors(true)
        setIsLoading(false)
        console.error(error)
        return null;
      }
    }

      const [sites,groups] =await Promise.all([fetchSites(),fetchGroups(emmsId)])

      if (groups == null) {
          setIsLoading(false);
          return null;
        }

      const requestBody = {
      path: "user",
      query: {},
      body: {},
      requestType: "GET",
    };

    const toBoolean = (value) => value === true || value === "true";

    axios
      .post(api + "/auth/piggyback", requestBody, headers)
        .then((response) => {
          const transformedData = response?.data?.map((user) => ({
          id: user.id,
          email: user.email,
          tabs: user.customProperties?.tabs?.join(", ") || "",
          admin: toBoolean(user.customProperties?.admin),
          maker: toBoolean(user.customProperties?.maker),
          checker: toBoolean(user.customProperties?.checker),
          isMFAEnabled: toBoolean(user?.isMFAEnabled),
          isSuperAdmin: toBoolean(user?.superadmin),
          isOwnProfile:loggedInUser?.id==user.id,
          sites:
                sites
                  ?.flatMap((site) =>
                    user?.siteIds?.includes(site.id) && site.name ? [site.name] : []
                  )
                  .join(", ") || "",
          groups:
                  groups
                    ?.filter((group) => user?.customProperties?.belongsTo?.includes(group.id))
                    ?.map((group) => group.name)
                    ?.join(", ") || "",
           groupIds:user.customProperties?.belongsTo || []
                    
                }));


         setUsers(transformedData)
          setErrors(false);
        })
        .catch((e) => {
          console.error("Failed to fetch users ",e)
          setErrors(true);
        })
        .finally(() => {
          setIsLoading(false);
        });
  };

  useEffect(() => {
    fetchData();
  }, []);

  

  return (
    <div className="mainContainer emms-main-container">
      <header className="no-margin">
                    <figure className="emms-image-figure">
                      <img className="img emm-image" src={'https://storage.googleapis.com/content_ai_bucket_elhitech/content/users_banner.png'} alt="Logo" />
                    </figure>
          </header>
      <div className="title-container">
        <div className="title">
          
        </div>
        <div>
          <MyUserForm  editMode={!!selectedUserForEdit?.id} userData={selectedUserForEdit} setSelectedUserForEdit={setSelectedUserForEdit}  sites={sites} setUsers={setUsers} groups={groups} />
        </div>
      </div>

      <div  className="emms-main-container-left-align" style={{ marginLeft: "10%" }}>
        <Users  errors={errors} isLoading={isLoading} setUsers={setUsers} users={users} setSelectedUserForEdit={setSelectedUserForEdit} selectedUserForDelete={selectedUserForDelete} setSelectedUserForDelete={setSelectedUserForDelete} sites={sites} />
      </div>
    </div>
  );
}


